<template>
  <div>
    <v-dialog v-model="showWelcomeDialog" contained max-width="400" :persistent="!dataLoaded" class="custom-dialog">
      <v-card rounded="lg">
        <template #text>
          <div class="text-center pt-4">
            
            <v-progress-circular
                v-if="!projectName || loadingData"
                indeterminate
                color="primary"
                size="x-large"
                class="mb-4"
            />
            <v-avatar
              v-else
              class="mb-4 cursor-pointer"
              color="success"
              size="x-large"
              variant="tonal"
              icon="mdi-check"
              @dblclick="copyQueryString"
            ></v-avatar>

            <div class="font-weight-bold mb-2">
              {{ $t('welcomeMessage', { projectName: projectName }) }}
            </div>

            <div class="text-body-2 text-medium-emphasis mb-6"></div>

            <v-progress-linear
              v-if="!projectName || loadingData"
              :model-value="progressValue"
              color="primary"
              height="2"
              class="mb-4"
              stream
            />

            <v-btn
              v-if="projectName"
              block
              class="text-none"
              color="primary"
              :disabled="loadingData || !isDuckDBInitialized"
              variant="flat"
              @click="loadDashboard"
            >
              {{ $t('loadDashboard') }}
            </v-btn>
          </div>
        </template>
      </v-card>
    </v-dialog>

    <!-- Toast Message -->
    <v-snackbar
      v-model="showToast"
      :timeout="2000"
      color="success"
      location="top"
    >
      Dev mode activated
    </v-snackbar>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useAnalytics } from '@/utils/useAnalytics'

const store = useStore();
const { trackEvent } = useAnalytics()

const showWelcomeDialog = computed(() => store.getters.getShowWelcomeDialog);
const isDuckDBInitialized = computed(() => store.getters.isDuckDBInitialized);
const showToast = ref(false);

const projectName = computed(() => store.getters.getProjectName);
const loadingData = ref(false);
const dataLoaded = computed(() => store.getters.getDataLoaded);

// Props for progress tracking
const props = defineProps({
  apiProgress: {
    type: Number,
    required: true
  },
  totalApiRequests: {
    type: Number,
    required: true
  }
});

// Compute the progress percentage
const progressValue = computed(() => {
  return (props.apiProgress / props.totalApiRequests) * 100;
});

const copyQueryString = async () => {
  try {
    const queryString = window.location.search;
    await navigator.clipboard.writeText(queryString);
    showToast.value = true;
    
    // Track the copy event
    trackEvent('copyQueryString', {
      action_type: 'avatar_double_click',
      project_code: store.getters.getProjectCode,
      project_name: store.getters.getProjectName
    });
  } catch (err) {
    console.error('Failed to copy query string:', err);
  }
};

const loadDashboard = async () => {
  trackEvent('loadDashboard', {
    action_type: 'button_click',
    project_code: store.getters.getProjectCode,
    project_name: store.getters.getProjectName
  })

  loadingData.value = true;
  await store.dispatch('updateLoadDashboard', true);
};

watch(dataLoaded, (newValue) => {
  if (newValue) {
    showWelcomeDialog.value = false;
  }
});

watch(showWelcomeDialog.value, (newValue) => {
  if (newValue) {
    showWelcomeDialog.value = false;
  }
});

</script>

<style>
.v-dialog .v-overlay__content {
  top: 20vh !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>